export default __webpack_public_path__ + "static/media/kitchen3-afterG-480w.ef448da1.webp";